import React from "react";
import { Button, Modal, Table, Spinner } from '@themesberg/react-bootstrap';
import { useCookies } from "react-cookie";
import { AddTicketTableActionRow } from "./component/AddTicketTableActionRow";
import { AddTicketTableRow } from "./component/AddTicketTableRow";
import { AddPairTicketTableRow } from "./component/AddPairTicketTableRow";
import { addStorage, addPairStorage } from "../../../../../controller/api/__classic__/input";

export default (props) => {

  const [cookies] = useCookies(['lottmekong'])

  const [singleData, setSingleData] = React.useState([]);
  const [pairData, setPairData] = React.useState([]);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const maxDigits = props.region === 'MB' ? 5 : 6

  const _onHide = () => {
    if (isSubmitting) return
    setSingleData([])
    setPairData([])
    props.onHide()
  }

  const onSubmit = async () => {
    const validSingleData = singleData.filter(it => it.numbers.length === maxDigits && it.amount !== '')
    const validPairData = pairData.filter(it => it.last5Numbers.length === 5 && it.amount !== '')
    
    if (validSingleData.length === 0 && validPairData.length === 0) {
      alert('Vui lòng nhập ít nhất 1 vé hợp lệ')
      return
    }
    
    setIsSubmitting(true)
    try {
      let hasError = false
      let errorMessages = []

      if (validSingleData.length > 0) {
        const resp = await addStorage(cookies.lottmekong, props.id, validSingleData, props.isDirectSale)
        if (!resp || !resp.success) {
          hasError = true
          errorMessages.push('Vé đơn: ' + (resp?.error || resp?.message || 'Unknown error'))
        }
      }

      if (validPairData.length > 0) {
        const resp = await addPairStorage(cookies.lottmekong, props.id, validPairData, props.isDirectSale)
        if (!resp || !resp.success) {
          hasError = true
          errorMessages.push('Vé cặp: ' + (resp?.error || resp?.message || 'Unknown error'))
        }
      }

      if (hasError) {
        alert('Có lỗi xảy ra:\n' + errorMessages.join('\n'))
      } else {
        const pairCount = validPairData.length * 10
        const singleCount = validSingleData.length
        const message = pairCount > 0 && singleCount > 0 
          ? `Thêm thành công ${singleCount} vé đơn và ${pairCount} vé cặp nguyên!`
          : pairCount > 0 
            ? `Thêm thành công ${pairCount} vé cặp nguyên!`
            : `Thêm thành công ${singleCount} vé đơn!`
        alert(message)
        setSingleData([])
        setPairData([])
        props.onHide()
        if (props.onSuccess) props.onSuccess()
      }
    } catch (error) {
      alert('Lỗi: ' + error.message)
    } finally {
      setIsSubmitting(false)
    }
  }

  const onAddSingle = () => {
    const newData = [...singleData]
    newData.push({
      numbers: '',
      amount: '',
      images: null
    })
    setSingleData(newData)
  }

  const onAddPair = () => {
    const newData = [...pairData]
    newData.push({
      last5Numbers: '',
      amount: '',
      images: null
    })
    setPairData(newData)
  }

  const onChangeSingleAmount = (index, amount) => {
    const newData = JSON.parse(JSON.stringify(singleData))
    newData[index].amount = amount
    setSingleData(newData)
  }

  const onChangeSingleNumbers = (index, numbers) => {
    const trimmedNumbers = numbers.trim()
    if (trimmedNumbers.length > maxDigits) {
      return
    }
    const newData = JSON.parse(JSON.stringify(singleData))
    newData[index].numbers = trimmedNumbers
    setSingleData(newData)
  }

  const onChangeSingleImage = (index, imageFile) => {
    const newData = [...singleData]
    newData[index] = {
      ...newData[index],
      images: imageFile
    }
    setSingleData(newData)
  }
  
  const onDeleteSingle = (index) => {
    const newData = singleData.filter((it, idx) => idx !== index)
    setSingleData(newData)
  }

  const onChangePairAmount = (index, amount) => {
    const newData = JSON.parse(JSON.stringify(pairData))
    newData[index].amount = amount
    setPairData(newData)
  }

  const onChangePairLast5Numbers = (index, numbers) => {
    const trimmedNumbers = numbers.trim()
    if (trimmedNumbers.length > 5) {
      return
    }
    const newData = JSON.parse(JSON.stringify(pairData))
    newData[index].last5Numbers = trimmedNumbers
    setPairData(newData)
  }

  const onChangePairImage = (index, imageFile) => {
    const newData = [...pairData]
    newData[index] = {
      ...newData[index],
      images: imageFile
    }
    setPairData(newData)
  }
  
  const onDeletePair = (index) => {
    const newData = pairData.filter((it, idx) => idx !== index)
    setPairData(newData)
  }

  const totalTickets = singleData.length + pairData.length

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onHide={_onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.channelName} {props.resultDate}
          {props.isDirectSale && (
            <span style={{ color: '#e74a3b', fontSize: '14px', marginLeft: '15px', fontWeight: 'normal' }}>
              (Vé sẽ được bán ngay sau khi thêm)
            </span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">STT</th>
              <th scope="col">Dãy số</th>
              <th scope="col">Số lượng</th>
              <th scope="col">Hình</th>
              <th scope="col">Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {singleData.map((it, idx) => (
              <AddTicketTableRow 
                onDelete={onDeleteSingle} 
                onChangeNumbers={onChangeSingleNumbers} 
                onChangeAmount={onChangeSingleAmount} 
                onChangeImage={onChangeSingleImage} 
                rIndex={idx} 
                key={`single-ticket-${idx}`} 
                maxDigits={maxDigits}
                {...it} 
              />
            ))}
            {pairData.map((it, idx) => (
              <AddPairTicketTableRow 
                onDelete={onDeletePair} 
                onChangeLast5Numbers={onChangePairLast5Numbers} 
                onChangeAmount={onChangePairAmount} 
                onChangeImage={onChangePairImage} 
                rIndex={idx} 
                key={`pair-ticket-${idx}`} 
                {...it} 
              />
            ))}
          </tbody>
          <tfoot>
            <AddTicketTableActionRow
              region={props.region}
              onAddSingle={onAddSingle}
              onAddPair={onAddPair}
            />
          </tfoot>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={_onHide} disabled={isSubmitting}>Close</Button>
        <Button variant="primary" onClick={onSubmit} disabled={isSubmitting || totalTickets === 0}>
          {isSubmitting ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" className="me-2" />
              Đang thêm...
            </>
          ) : 'Thêm'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
